// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FrtZ","delete":"styles_delete__3O8An","update":"styles_update__1gFI_","add":"styles_add__1xXRC"};